import React, { useEffect, useState } from 'react'
import { Box, FormControl, Grid, MenuItem, Select, TextField, Typography } from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import Helper from '../../../../utils/helper'
import { checkCondition } from '../common/condition-check'
import stylesheet from '../detail-container.stylesheet'
interface IProps {
  details: any
  isOtherMed: any
  outerSubmit: any
  classes: ClassNameMap
}

const DetailComponent: React.FC<IProps> = ({ details, isOtherMed, outerSubmit, classes }) => {
  const uiResource = useSelector((state: RootState) => state.metaData.metadata)
  const _schedule = details.c_schedule //details.c_schedule
  const _porder = details.pu_order
  const _rec_sch = details?.is_recommended ? details?.aa_rec : details?.c_schedule
  const directions = checkCondition(details?.titration_status.includes('discontinue'), checkCondition(_rec_sch?.directions?.dc, _rec_sch?.directions?.dc, '-'), checkCondition(_rec_sch?.directions?.init, _rec_sch?.directions?.init, '-'))
  const [daysSupply, setDaysSupply] = useState(details.days_supply || '' as any)
  const [disallowSub, setDisallowSub] = useState(details.disallow_substitution as any)
  const [doseStartDate, setDoseStartDate] = useState(
    details.current_dose_start_date
      ? new Date(details.current_dose_start_date * 1000).toISOString().split('T')[0]
      : ''
  )

  const handleInputChange = (e: any) => {
    if (e.target.name === 'days_supply')
      setDaysSupply(e.target.value)
    if (e.target.name === 'disallow_substitution')
      setDisallowSub(e.target.value)
    if (e.target.name === 'current_dose_start_date') {
      setDoseStartDate(e.target.value)
      const ts = e.target.value ? Math.floor(new Date(e.target.value + 'T12:00:00').getTime() / 1000) : null
      outerSubmit(e.target.name, ts)
      return
    }
    outerSubmit(e.target.name, e.target.value)
  }

  return (
    <Box p={1}>
      <Box mb={2}>
        <Grid container xs={12} direction="row" alignItems="center">
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary" className={classes.evalBoxLabel}>
              Name
            </Typography>
            <Grid container xs={12} direction="row" alignItems="center">
              <Typography variant="body2" className={classes.evalBoxVal}>
                <strong>
                  {checkCondition(_schedule?.aa_form, Helper.getRXnorm(_schedule?.aa_form, _schedule?.rxnorm), '-')}
                </strong>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box mb={2}>
        <Grid container xs={12} direction="row" alignItems="center">
          <Grid item xs={3}>
            <Typography variant="body2" color="textSecondary" className={classes.evalBoxLabel}>
              Schedule name
            </Typography>
            <Grid container xs={12} direction="row" alignItems="center">
              <Typography variant="body2" className={classes.evalBoxVal}>
                <strong>
                  {checkCondition(_schedule?.schedule_display_name, _schedule?.schedule_display_name, '-')}
                </strong>
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" color="textSecondary" className={classes.evalBoxLabel}>
              Number of units
            </Typography>
            <Grid container xs={12} direction="row" alignItems="center">
              <Typography variant="body2" className={classes.evalBoxVal}>
                <strong>
                  {checkCondition(_porder?.num_units && (_schedule?.aa_form || _schedule?.schedule_display_name), `${_porder?.num_units}`, '-')}
                </strong>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box mb={2}>
        <Grid container xs={12} direction="row" alignItems="center">
          <Grid item xs={3}>
            <Typography variant="body2" color="textSecondary" className={classes.evalBoxLabel}>
              Frequency
            </Typography>
            <Grid container xs={12} direction="row" alignItems="center">
              <Typography variant="body2" className={classes.evalBoxVal}>
                <strong>
                  {checkCondition(uiResource.MEDICATION_DOSAGE_FREQUENCY[_porder?.frequency] && (_schedule?.aa_form || _schedule?.schedule_display_name), uiResource.MEDICATION_DOSAGE_FREQUENCY[_porder?.frequency], '-')}
                </strong>
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" color="textSecondary" className={classes.evalBoxLabel}>
              Route
            </Typography>
            <Grid container xs={12} direction="row" alignItems="center">
              <Typography variant="body2" className={classes.evalBoxVal}>
                <strong>
                  {checkCondition(_porder?.route && (_schedule?.aa_form || _schedule?.schedule_display_name), _porder?.route, '-')}
                </strong>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Grid container xs={12} direction="row" alignItems="center" mb={1}>
        <Grid item xs={3}>
          <Typography variant="body2" color="textSecondary" className={classes.evalBoxLabel}>
            Max Dose
          </Typography>
          <Grid container xs={12} direction="row" alignItems="center">
            <Typography variant="body2" className={classes.evalBoxVal}>
              <strong>
                {checkCondition(_schedule?.max_dose, `${_schedule?.max_dose} ${_schedule?.unit}`, '-')}
              </strong>
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body2" color="textSecondary" className={classes.evalBoxLabel}>
            Directions
          </Typography>
          <Grid container xs={12} direction="row" alignItems="center">
            <Typography variant="body2" className={classes.evalBoxVal}>
              {/* <strong>{checkCondition(_schedule?.directions, _schedule?.directions, '-')}</strong> */}
              <strong>{directions}</strong>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container xs={12} direction="row" alignItems="center" mb={1}>
        <Grid item xs={3}>
          <Typography variant="body2" color="textSecondary" className={classes.evalBoxLabel}>
            Current dose started
          </Typography>
          <Grid container xs={12} direction="row" alignItems="center">
            <TextField
              variant="standard"
              size="small"
              type="date"
              value={doseStartDate}
              onChange={handleInputChange}
              name="current_dose_start_date"
              InputLabelProps={{ shrink: true }}
              inputProps={{ max: new Date().toISOString().split('T')[0] }}
              sx={{ width: '100%' }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container xs={12} direction="row" alignItems="center">
        <Grid item xs={3}>
          <Typography variant="body2" color="textSecondary" className={classes.evalBoxLabel}>No. supply</Typography>
          <Grid container xs={12} direction="row" alignItems="center">
            <TextField
              variant="standard"
              size="small"
              type="number"
              value={daysSupply}
              onChange={handleInputChange}
              name="days_supply"
              className={classes.medicationTextField}
            />
          </Grid>
        </Grid>
        <Grid item xs={2.1}>
          <Typography color="textSecondary" className={classes.evalBoxLabel} variant="body2">
            Disallow substitution
          </Typography>
          <FormControl className={classes.fullWidth}>
            <Select
              displayEmpty
              variant="standard"
              className={classes.selectEmpty}
              inputProps={{ 'aria-label': 'disallow_substitution' }}
              value={disallowSub}
              name="disallow_substitution"
              MenuProps={{ autoFocus: false }}
              onChange={handleInputChange}
            >
              <MenuItem className={classes.formControlItemsPadding} value={true as any}>Yes</MenuItem>
              <MenuItem className={classes.formControlItemsPadding} value={false as any}>No</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  )
}

export default withStyles(stylesheet)(DetailComponent)
